// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : EXCEL PART REMOVED
// MODFIED DATA : 27-09-2025

import { makeApiCall } from '../../../_common/api.utils';
import { FIN_API_URL } from '../../../const';

/** ***************** GET RECEIPTS PAYMENTS START *********************** */
export const ReceiptsPaymentsListGet = (listData: any) => {
	const data = {
		GetReceiptsPaymentsToken: listData,
	};
	const url = `${FIN_API_URL}getReceiptsPayments`;
	return makeApiCall(url, data);
};
/** ***************** GET RECEIPTS PAYMENTS END *********************** */
